module.exports = __webpack_public_path__ + "static/media/Cadets.68bd619e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/Cadets.jpg
// module id = 290
// module chunks = 0